import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Facebook, Instagram, MessageCircle } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Brand Section */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_f35f5b38-6d8d-497e-9765-fd0e7def8902/artifacts/xg4tz6vt_prestanet-80x80.png" 
                alt="PrestaNet Logo" 
                className="h-12 w-12"
              />
              <span className="text-2xl font-bold bg-gradient-to-r from-amber-400 to-emerald-400 bg-clip-text text-transparent">
                PrestaNet
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Tu aliado financiero de confianza. Préstamos accesibles de persona a persona con la mejor atención.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-amber-400">Enlaces Rápidos</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-slate-400 hover:text-amber-400 transition-colors text-sm">
                  Inicio
                </Link>
              </li>
              <li>
                <Link to="/nosotros" className="text-slate-400 hover:text-amber-400 transition-colors text-sm">
                  Nosotros
                </Link>
              </li>
              <li>
                <Link to="/como-funciona" className="text-slate-400 hover:text-amber-400 transition-colors text-sm">
                  Cómo Funciona
                </Link>
              </li>
              <li>
                <Link to="/sucursales" className="text-slate-400 hover:text-amber-400 transition-colors text-sm">
                  Sucursales
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-slate-400 hover:text-amber-400 transition-colors text-sm">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-amber-400">Contacto</h3>
            <ul className="space-y-3">
              <li>
                <a href="tel:3329698523" className="flex items-start gap-2 text-slate-400 hover:text-amber-400 transition-colors text-sm">
                  <Phone size={16} className="mt-0.5 flex-shrink-0" />
                  <span>33 2969 8523</span>
                </a>
              </li>
              <li>
                <a href="mailto:quierocredito@prestanet.com.mx" className="flex items-start gap-2 text-slate-400 hover:text-amber-400 transition-colors text-sm">
                  <Mail size={16} className="mt-0.5 flex-shrink-0" />
                  <span>quierocredito@prestanet.com.mx</span>
                </a>
              </li>
              <li>
                <div className="flex items-start gap-2 text-slate-400 text-sm">
                  <MapPin size={16} className="mt-0.5 flex-shrink-0" />
                  <span>Guadalajara, Michoacán, Guerrero, Colima, San Luis Potosí, Tepic</span>
                </div>
              </li>
            </ul>
          </div>

          {/* Schedule & Social */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-amber-400">Horarios</h3>
            <p className="text-slate-400 text-sm mb-4">
              Lunes a Viernes:<br />
              9:00 AM - 6:00 PM<br /><br />
              Sábado:<br />
              9:00 AM - 2:00 PM
            </p>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-amber-500 transition-colors">
                <Facebook size={18} />
              </a>
              <a href="#" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-amber-500 transition-colors">
                <Instagram size={18} />
              </a>
              <a href="https://wa.me/5213329698523" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center hover:bg-emerald-500 transition-colors">
                <MessageCircle size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-slate-500 text-sm text-center md:text-left">
              © 2024 PrestaNet. Todos los derechos reservados.
            </p>
            <div className="flex gap-6 text-sm">
              <Link to="/terminos-y-condiciones" className="text-slate-500 hover:text-amber-400 transition-colors">
                Términos y Condiciones
              </Link>
              <Link to="/privacidad" className="text-slate-500 hover:text-amber-400 transition-colors">
                Privacidad
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Floating WhatsApp Button */}
      <a
        href="https://wa.me/5213329698523?text=Hola,%20quiero%20información%20sobre%20un%20crédito"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-14 h-14 bg-emerald-500 hover:bg-emerald-600 text-white rounded-full shadow-lg hover:shadow-xl flex items-center justify-center transition-all z-50 animate-bounce hover:animate-none"
        aria-label="Chat en WhatsApp"
      >
        <MessageCircle size={28} />
      </a>
    </footer>
  );
};
